if (!customElements.get('saux-sock-product')) {
  customElements.define(
    'saux-sock-product',
    class SauxSockProduct extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const json = this.querySelector('[data-variants]');
        if (!json) return;

        try {
          this.variants = JSON.parse(json.textContent);
        } catch (_error) {
          return;
        }

        this.packIndex = Number(this.dataset.packOptionIndex || 0);
        this.packInputs = [...this.querySelectorAll('[data-pack-input]')];
        this.optionSelects = [...this.querySelectorAll('[data-option-select]')];
        this.variantInput = this.querySelector('[data-variant-id]');
        this.submitButton = this.querySelector('.saux-sock__add');
        this.selectionError = this.querySelector('[data-selection-error]');
        const listenerOptions = { signal: this.controller.signal };

        this.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
          button.addEventListener('click', () => this.selectImage(button), listenerOptions);
        });
        this.packInputs.forEach((input) => input.addEventListener('change', () => this.updateSelection(), listenerOptions));
        this.optionSelects.forEach((select) => select.addEventListener('change', () => this.updateSelection(), listenerOptions));
        this.updateSelection();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      selectedOptions(packValue) {
        const selectedPack = packValue || this.packInputs.find((input) => input.checked)?.value;
        const values = [];
        values[this.packIndex] = selectedPack;
        this.optionSelects.forEach((select) => {
          values[Number(select.dataset.optionIndex)] = select.value;
        });
        return values;
      }

      findVariant(packValue) {
        const values = this.selectedOptions(packValue);
        return this.variants.find((variant) => variant.options.every((value, index) => values[index] === value));
      }

      updateSelection() {
        this.packInputs.forEach((input) => {
          const variant = this.findVariant(input.value);
          const anyAvailable = this.variants.some((item) => item.options[this.packIndex] === input.value && item.available);
          const card = input.closest('[data-pack-card]');
          input.disabled = !anyAvailable;
          card?.classList.toggle('is-unavailable', !anyAvailable);
          card?.classList.toggle('is-selected', input.checked);
          this.updatePackPrice(card, variant);
        });

        const active = this.packInputs.find((input) => input.checked) || this.packInputs.find((input) => !input.disabled);
        if (active && !active.checked) active.checked = true;
        this.packInputs.forEach((input) => input.closest('[data-pack-card]')?.classList.toggle('is-selected', input === active));
        this.updateVariant(active ? this.findVariant(active.value) : null);
        this.selectPackImage(active);
      }

      updatePackPrice(card, variant) {
        if (!card) return;
        const price = card.querySelector('[data-pack-price]');
        const compare = card.querySelector('[data-pack-compare]');
        const saving = card.querySelector('[data-pack-saving]');
        const savingValue = card.querySelector('[data-pack-saving-value]');
        const valid = Boolean(variant && Number(variant.comparisonReference) > Number(variant.price));
        if (price) price.textContent = variant ? variant.priceFormatted : 'Unavailable';
        if (compare) {
          compare.textContent = valid ? variant.comparisonReferenceFormatted : '';
          compare.hidden = !valid;
        }
        if (saving) saving.hidden = !valid;
        if (savingValue) savingValue.textContent = valid ? variant.comparisonSavingFormatted : '';
      }

      updateVariant(variant) {
        const price = this.querySelector('[data-current-price]');
        const compare = this.querySelector('[data-current-compare]');
        const saving = this.querySelector('[data-current-saving]');
        const savingValue = this.querySelector('[data-current-saving-value]');
        const copy = this.querySelector('[data-comparison-copy]');
        const available = Boolean(variant?.available);
        const valid = Boolean(variant && Number(variant.comparisonReference) > Number(variant.price));

        if (this.variantInput) this.variantInput.value = variant?.id || '';
        if (price) price.textContent = variant ? variant.priceFormatted : 'Unavailable';
        if (compare) {
          compare.textContent = valid ? variant.comparisonReferenceFormatted : '';
          compare.hidden = !valid;
        }
        if (saving) saving.hidden = !valid;
        if (savingValue) savingValue.textContent = valid ? variant.comparisonSavingFormatted : '';
        if (copy) {
          const showCopy = valid && this.dataset.comparisonMode === 'bulk' && Boolean(variant.comparisonCopy);
          copy.textContent = showCopy ? variant.comparisonCopy : '';
          copy.hidden = !showCopy;
        }
        if (this.submitButton) {
          this.submitButton.disabled = !available;
          this.submitButton.setAttribute('aria-disabled', String(!available));
          this.submitButton.querySelector('[data-add-label]')?.classList.toggle('hidden', !available);
          this.submitButton.querySelector('.sold-out-message')?.classList.toggle('hidden', available);
        }
        if (this.selectionError) this.selectionError.hidden = available;
      }

      selectImage(button) {
        const image = this.querySelector('[data-main-image]');
        if (!image) return;
        image.src = button.dataset.imageSrc;
        image.removeAttribute('srcset');
        image.alt = button.dataset.imageAlt || '';
        image.width = Number(button.dataset.imageWidth || image.width);
        image.height = Number(button.dataset.imageHeight || image.height);
        image.classList.remove('is-pack-image');
        this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
          const active = thumb === button;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', String(active));
        });
      }

      selectPackImage(input) {
        const image = this.querySelector('[data-main-image]');
        if (!image || !input?.dataset.packImageSrc) return;
        image.src = input.dataset.packImageSrc;
        image.removeAttribute('srcset');
        image.alt = input.dataset.packImageAlt || '';
        image.width = Number(input.dataset.packImageWidth || image.width);
        image.height = Number(input.dataset.packImageHeight || image.height);
        image.classList.add('is-pack-image');
        this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
          thumb.classList.remove('is-active');
          thumb.setAttribute('aria-pressed', 'false');
        });
      }
    }
  );
}
